import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from './AuthLayout';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { twoFaVerify } from '../../store/user/userThunk';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useRef } from 'react';

const schema = yup.object().shape({
  digit1: yup.string().required(),
  digit2: yup.string().required(),
  digit3: yup.string().required(),
  digit4: yup.string().required(),
  digit5: yup.string().required(),
  digit6: yup.string().required(),
});

const BottomLink = () => (
  <div className="w-full text-center">
    <p className="text-gray-500 leading-6 text-base">
      Don't have an account?{' '}
      <Link to="/auth/sign-up" className="text-primary font-semibold ms-1">
        Sign Up
      </Link>
    </p>
  </div>
);

const FaVerify = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.userservice);

  const {
    handleSubmit,
    setValue,
    register,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });

  // Declare refs at top level
  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRefs = [inputRef1, inputRef2, inputRef3, inputRef4, inputRef5, inputRef6];

  const handleOtpChange = (e, index) => {
    const value = e.target.value;

    // If user pastes full 6-digit OTP
    if (value.length === 6 && /^[0-9]+$/.test(value)) {
      value.split('').forEach((digit, i) => {
        setValue(`digit${i + 1}`, digit);
        if (inputRefs[i].current) {
          inputRefs[i].current.value = digit;
        }
      });
      inputRefs[5].current.focus();
      return;
    }

    // Handle single digit input
    if (/^[0-9]?$/.test(value)) {
      setValue(`digit${index + 1}`, value);
      if (value && index < 5) {
        inputRefs[index + 1].current.focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' && !e.target.value && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  const onSubmit = (data) => {
    const otp = `${data.digit1}${data.digit2}${data.digit3}${data.digit4}${data.digit5}${data.digit6}`;
    dispatch(twoFaVerify(otp))
      .unwrap()
      .then((result) => {
        Cookies.set('twofatoken', result?.payload?.accessToken);
        toast.success('Verification Successful');
        navigate('/dashboards');
      })
      .catch(() => {
        toast.error('OTP verification failed');
      });
  };

  return (
    <AuthLayout
      authTitle=""
      helpText=""
      bottomLinks={<BottomLink />}
      isOtpStep={true}
    >
          {/* max-width: 62px;
    margin: auto;
    border: 3px solid black;
    border-radius: 50%;
} */}
      <div>
  <img
    src={require('../../assets/images/login/2fa.png')}
    className="max-w-[62px] mx-auto  rounded-full"
    alt="2FA"
  />
</div>

      <div>
         <h6 className="text-base/[1.6] font-semibold text-gray-600 mb-0 mt-4">
                    Welcome back
                  </h6>
                  <p className="text-gray-500 text-sm/[1.6] mt-1 mb-6">
                 Enter your Verify Code to access the admin panel
                  </p>
      </div>
      <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col items-center gap-6">
        <div className="flex gap-2 justify-center">
          {[0, 1, 2, 3, 4, 5].map((index) => (
            <input
              key={index}
              type="text"
              maxLength="6"
              className="w-12 h-12 text-center text-lg border border-gray-300 rounded-md focus:outline-none focus:border-primary"
              {...register(`digit${index + 1}`)}
              ref={inputRefs[index]}
              onChange={(e) => handleOtpChange(e, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          ))}
        </div>

        {Object.keys(errors).length > 0 && (
          <span className="text-danger text-sm text-center">
            Please enter all 6 digits of the OTP
          </span>
        )}  

        <button
          className="w-full bg-primary text-white font-medium py-2 px-4 rounded-md transition-all hover:shadow-lg"
          type="submit"
          disabled={loading}
        >
          {loading ? 'Verifying...' : 'Submit'}
        </button>
      </form>
    </AuthLayout>
  );
};

export default FaVerify;
